import { Box, CircularProgress, useTheme } from '@mui/material';
import AuthLayout from 'components/layout/AuthLayout';
import { PAGE_LIST } from 'constant/pages';
import HomePage from 'pages/Home';
import { LoginPage } from 'pages/Login';
import SettingPage from 'pages/Setting';
import QueryString from 'qs';
import {
  createBrowserRouter,
  Navigate,
  redirect,
  RouterProvider,
} from 'react-router-dom';
import { getUser } from 'utils/fetch';

function App() {
  const theme = useTheme();
  const getTokenFromQueryStrAndGetAuth = async (str: string) => {
    const queryString = str.split('?')[1];
    const query = QueryString.parse(queryString);
    return await getUser(query?.accessToken as string | undefined);
  };

  const router = createBrowserRouter([
    {
      path: PAGE_LIST.LOGIN.pathname(),
      loader: async ({ request }) => {
        return await getTokenFromQueryStrAndGetAuth(request.url);
      },
      element: <Navigate to={PAGE_LIST.HOME.pathname()} />,
      errorElement: <LoginPage />,
    },
    {
      path: '/',
      element: <HomePage />,
      loader: async ({ request }) => {
        const localAccessToken = localStorage.getItem('accessToken');
        if (!localAccessToken) {
          throw redirect(PAGE_LIST.SETTING.pathname());
        }
        return await getTokenFromQueryStrAndGetAuth(request.url);
      },
      errorElement: <Navigate to={PAGE_LIST.LOGIN.pathname()} />,
    },
    {
      element: <AuthLayout />,
      loader: async ({ request }) => {
        return await getTokenFromQueryStrAndGetAuth(request.url);
      },
      children: [
        {
          path: PAGE_LIST.SETTING.pathname(),
          element: <SettingPage />,
        },
      ],
    },
  ]);

  return (
    <RouterProvider
      router={router}
      fallbackElement={
        <Box
          sx={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress sx={{ color: theme.palette.primary.main }} />
        </Box>
      }
    />
  );
}

export default App;
